/**
 * @Author: v_jppjpeng
 * @Date: 2022-10-25 11:45:05
 * @Explain: 活动管理
 */

export interface ActivityState {
  /** 是否显示创建活动 - 弹窗 */
  createCampaignOptions: {
    isShow: boolean;
  };
  /** 是否内部跳转 */
  isInternalJump: boolean;
  /** 是否开启跳出拦截 */
  isLeaveFlag: boolean;
  /** 选择内容 - 语言tab选中项 */
  languageActive: string;
  /** 草稿缓存 */
  draftCache: {
    id: number;
    tag: string;
    time: 0;
    saveList: any[];
    expandedList: any[];
  };
}

export type ModelType = {
  namespace: string;
  state: ActivityState;
  reducers: {
    setCreateCampaignOptions: (
      state: ActivityState,
      action: { payload: any },
    ) => any;
    setInterceptRouteStatus: (
      state: ActivityState,
      action: { payload: any },
    ) => any;
    setTabsActive: (state: ActivityState, action: { payload: any }) => any;
    setDraftCache: (state: ActivityState, action: { payload: any }) => any;
    resetDraftCache: (state: ActivityState, action: { payload: any }) => any;
  };
};

const ActivityModel: ModelType = {
  namespace: 'ActivityModel',
  state: {
    // 是否显示创建活动 - 弹窗
    createCampaignOptions: {
      isShow: false,
    },
    // 是否内部跳转
    isInternalJump: false,
    // 是否开启跳出拦截
    isLeaveFlag: false,
    // 选择内容 - 语言tab选中项
    languageActive: '',
    // 草稿缓存
    draftCache: {
      id: 0,
      tag: '',
      time: 0,
      saveList: [],
      expandedList: [],
    },
  },
  reducers: {
    // 设置创建活动 - 弹窗配置
    setCreateCampaignOptions(state, action) {
      return {
        ...state,
        createCampaignOptions: action.payload,
      };
    },
    // 设置拦截路由状态
    setInterceptRouteStatus(state, action) {
      const { isInternalJump, isLeaveFlag } = action.payload;
      return {
        ...state,
        isInternalJump,
        isLeaveFlag,
      };
    },
    // 设置选择内容 - 语言tab选中项
    setTabsActive(state, action) {
      return {
        ...state,
        languageActive: action.payload,
      };
    },
    // 设置草稿缓存
    setDraftCache(state, action) {
      return {
        ...state,
        draftCache: action.payload,
      };
    },
    // 重置草稿缓存
    resetDraftCache(state, action) {
      return {
        ...state,
        draftCache: {
          id: 0,
          time: 0,
          saveList: [],
          expandedList: [],
        },
        languageActive: '',
      };
    },
  },
};

export default ActivityModel;
